import { Grid } from "@mui/material";
import { ProductCard } from "components/ui";
import { useGlobalContext } from "context/GlobalContext";
import useStockInCatalog from "hooks/useStockInCatalog";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { addToCart, initCart, removeFromCart } from "store/cartSlice";

function Product({ data, allData, isBtn }) {
  // const { addToCart, removeFromCart, cartData } = useGlobalContext();
  const { setBtnTitle, btnTitle } = useStockInCatalog(data);
  const location = useLocation();

  const dispatch = useDispatch();

  const cartData = useSelector((state) => state.cart.cartData);

  const selectedCartProducts = useMemo(
    () => ({
      ...data,
      isAddedInCart: true,
    }),
    [data]
  );

  const handleAddToCartBtn = React.useCallback(() => {
    dispatch(
      addToCart({
        product: selectedCartProducts,
        location: location,
      })

      // {
      //   product: selectedCartProducts,
      //   location: location,
      // }
    );
  }, [dispatch, selectedCartProducts]);

  const handleRemoveCart = React.useCallback(() => {
    dispatch(removeFromCart(selectedCartProducts));
  }, [dispatch, selectedCartProducts]);

  // const handleAddToCartBtn = () => {
  //   setBtnTitle("Added");
  //   addToCart(selectedCartProducts);
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  // const handleRemoveCart = () => {
  //   setBtnTitle("Add");
  //   removeFromCart(selectedCartProducts);
  //   sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  const isAddedInCart = useMemo(() => {
    return cartData.some((item) => item.styleNumber === data.styleNumber);
  }, [cartData]);

  useEffect(() => {
    setBtnTitle(isAddedInCart ? "Added" : "Add");
  }, [isAddedInCart]);

  useEffect(() => {
    dispatch(initCart());
  }, [dispatch]);

  return (
    <Grid key={data.id} item className="product">
      <ProductCard
        data={data}
        style={{ maxWidth: "474px", minWidth: "474px" }}
        allData={allData}
        isBtn={isBtn}
        btnTilte={btnTitle}
        addtoCart={handleAddToCartBtn}
        removeCart={handleRemoveCart}
        selectedCartProducts={selectedCartProducts}
      />
    </Grid>
  );
}

export default Product;
